<template>
	<el-card class="box-card result-card" shadow="never">
	  <div slot="header" class="clearfix">
	    <span>筛选结果 <b>10861条</b></span>
	  </div>
	  <div v-for="o in 4" :key="o" class="text item">
	    <p>
	      <el-checkbox v-model="checked"></el-checkbox>
	      <el-tag type="primary" size="mini" plain>Medline</el-tag>
	    </p>
	    <p><b>
				<router-link class="recommend" :to="{path:'details',query:{id:123456}}">
					1、Schwann cell apoptosis in Wallerian-degenerated sciatic nerve of the rat.
				</router-link>
			</b></p>
	    <p><b>作者：</b>Zhe · Chen/Chen Z,Zhengxing · Chen/Chen Z,Haixiao · Chen/Chen H,Hansong · Chen/Chen H,Tao · Zhou/Zhou T,Hongsheng · Lu/Lu H</p>
	    <p><b>刊名：</b>Chinese journal of traumatology = Zhonghua chuang shang za zhi</p>
	    <p><b>年卷期页：</b>220-8</p>
	    <p><b>摘要：</b>{"RESULTS":"(1) The test group showed Wallerian degeneration. The number of Schwann cells began to decrease at 24 h, obviously decreased on day 3 and 4, then began to increase from day 8 and formed Bung...</p>
	  </div>
	</el-card>
</template>

<script>
	export default {
	    name: "list",
	    data(){
	        return{
	           checked:false 
	        }
	    }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list.vue